import { useRef, useEffect } from "react";
import propsTypes from "prop-types";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { separateNum } from "../../utils";
import config from "../../utils/config";
import { cartsChanged } from "../../store/action/cart";
import Notification from "../../services/notification/Notification";
import CartService from "../../services/cart/Cart";
import Card from "../../components/card";
import {
  Col,
  Div,
  RightMBorder,
  ItemRight,
  ItemLeft,
  ItemRightBold,
  ItemLeftBold,
  ItemPrice,
  SideBarContainer,
} from "./style";

const SideBar = (props) => {
  let history = useRef(useHistory());

  const cartsRef = useRef(props?.carts);

  const { carts, theme, children, local, cartsChanged } = props;

  const location = history.current.location.pathname.split("/");

  const pathname = useRef(location[location.length - 1]);

  useEffect(() => {
    if (
      pathname.current !== "carts" &&
      cartsRef?.current?.items &&
      Object.keys(cartsRef?.current?.items).length <= 0
    ) {
      Notification.danger("ابتدا باید سفارش بدهید");

      history.current.push("/");
    }
  }, []);

  return (
    <>
      <Col className="col-12 text-right mb-2">
        <SideBarContainer>
          <Card className="p-3">
            <RightMBorder theme={theme}>
              <Div className="mt-2">
                <ItemRight theme={theme}>توضیحات</ItemRight>
                <textarea
                  className={`w-100 f-12 mt-2 m-0 p-0 texareaDes ${
                    theme?.isDarkTheme && "dark"
                  }`}
                  placeholder="توضیحات سفارش خود را اینجا بنویسید"
                  onBlur={(e) => {
                    CartService.changed(
                      carts,
                      "description",
                      e.target.value,
                      cartsChanged
                    );
                  }}
                  defaultValue={carts?.description}
                  disabled={pathname.current === "checkout"}
                />
              </Div>
              <Div className="mt-3">
                <ItemRight theme={theme}>قیمت غذاها</ItemRight>
                <ItemLeft className="float-left" theme={theme}>
                  {`${separateNum(
                    local
                      ? CartService.getCartPrice(carts)?.price
                      : carts?.items_total
                  )} ${config.currency}`}
                </ItemLeft>
              </Div>
              {pathname.current === "checkout" ? (
                <Div className="mt-2">
                  <ItemRight theme={theme}>هزینه ارسال</ItemRight>
                  <ItemLeft className="float-left" theme={theme}>
                    {`${separateNum(carts?.shipping?.price)} ${
                      config.currency
                    }`}
                  </ItemLeft>
                </Div>
              ) : (
                false
              )}
              {pathname.current === "checkout" ? (
                <>
                  <Div className="mt-2">
                    <ItemRight theme={theme}>هزینه بسته بندی</ItemRight>
                    <ItemLeft className="float-left" theme={theme}>
                      {`${separateNum(carts?.packing_price)} ${
                        config.currency
                      }`}
                    </ItemLeft>
                  </Div>
                  <Div className="mt-2">
                    <ItemRight theme={theme}>مالیات</ItemRight>
                    <ItemLeft className="float-left" theme={theme}>
                      {`${separateNum(carts?.tax)} ${config.currency}`}
                    </ItemLeft>
                  </Div>
                </>
              ) : (
                false
              )}
              <Div className="mt-2">
                <ItemRight theme={theme}>تخفیف</ItemRight>
                <ItemPrice className="float-left" theme={theme}>
                  {`${separateNum(
                    local
                      ? CartService.getCartPrice(carts)?.offer
                      : carts?.items_offer
                  )} ${config.currency}`}
                </ItemPrice>
              </Div>
            </RightMBorder>
            <Div className="mt-2">
              <ItemRightBold theme={theme}>جمع کل</ItemRightBold>
              <ItemLeftBold className="float-left" theme={theme}>
                {`${separateNum(
                  local
                    ? CartService.getCartPrice(carts)?.payable
                    : carts?.payable
                )} ${config.currency}`}
              </ItemLeftBold>
            </Div>
            {pathname.current === "carts" ? (
              <Div className="mt-3">
                <ItemRight theme={theme}>
                  هزینه‌ی ارسال در ادامه بر اساس آدرس، زمان و نحوه‌ی ارسال
                  انتخابی شما‌ محاسبه و به این مبلغ اضافه خواهد شد
                </ItemRight>
              </Div>
            ) : (
              false
            )}

            {children}
          </Card>
        </SideBarContainer>
      </Col>
    </>
  );
};

SideBar.propsTypes = {
  local: propsTypes.bool,
};

SideBar.defaultProps = {
  local: false,
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    theme: state.theme,
    carts: state.carts?.carts,
  };
};

export default connect(mapStateToProps, { cartsChanged })(SideBar);
